import { Box } from '@mui/material';
import BigNumber from 'bignumber.js';
import React, { useMemo } from 'react';

const DiscountCell = ({ discountLevel, price }) => {
  
  const cellText = useMemo(() => (discountLevel < 0 ? `BP${Math.abs(discountLevel)}` : `BM${Math.abs(discountLevel)}`), [discountLevel]);
  
  const calculatedPrice = useMemo(() => {
    // Convert everything to BigNumber for precision
    const bigPrice = new BigNumber(price);
    const bigDiscount = new BigNumber(discountLevel);
    const hundred = new BigNumber(100);
    
    // Do the calculations with BigNumber
    return bigPrice.multipliedBy(hundred.minus(bigDiscount).dividedBy(hundred));
  }, [discountLevel, price]);

  return (
    <Box className="discountCell">
      {discountLevel === 0 ? (
        <p style={{ background: '#FFD98F' }}>{cellText}</p>
      ) : discountLevel % 5 === 0 ? (
        <p style={{ color: '#FF5F1F' }}>{cellText}</p>
      ) : (
        <p>{cellText}</p>
      )}
      <p>${calculatedPrice.dp(2, BigNumber.ROUND_HALF_UP).toFixed(2)}</p>
    </Box>
  );
};

export default DiscountCell;